{
  "appName": "VynaEMR",
  "appTagline": "APAC 중심 전자의무기록 시스템",
  "developedByLabel": "개발",
  "loading": "로딩 중...",
  "save": "저장",
  "cancel": "취소",
  "delete": "삭제",
  "edit": "편집",
  "create": "생성",
  "search": "검색",
  "filter": "필터",
  "actions": "작업",
  "confirm": "확인",
  "back": "뒤로",
  "next": "다음",
  "previous": "이전",
  "submit": "제출",
  "reset": "초기화",
  "close": "닫기",
  "yes": "예",
  "no": "아니오",
  "ok": "확인",
  "error": "오류",
  "success": "성공",
  "warning": "경고",
  "info": "안내",
  "validation": {
    "required": "필수 입력 항목입니다",
    "invalidEmail": "올바르지 않은 이메일 주소입니다",
    "invalidPhone": "올바르지 않은 전화번호입니다",
    "invalidDate": "올바르지 않은 날짜입니다",
    "minLength": "최소 {{min}}자 이상 입력해 주세요",
    "maxLength": "최대 {{max}}자까지 입력 가능합니다",
    "passwordMismatch": "비밀번호가 일치하지 않습니다"
  },
  "form": {
    "fieldRequired": "{{field}}을(를) 입력해 주십시오",
    "selectOption": "항목을 선택해 주십시오",
    "discardConfirm": "저장되지 않은 변경 사항을 취소하시겠습니까?",
    "unsavedChanges": "저장되지 않은 변경 사항이 있습니다",
    "mustBeNonNegativeInteger": "{{field}}은(는) 0 이상의 정수여야 합니다",
    "mustBeNonNegativeNumber": "{{field}}은(는) 0 이상의 숫자여야 합니다"
  },
  "unsavedChanges": {
    "title": "저장되지 않은 변경 사항",
    "body": "저장되지 않은 변경 사항이 있습니다. 이 페이지를 떠나시겠습니까? 변경 내용이 사라집니다.",
    "stay": "머무르기",
    "leave": "나가기"
  },
  "messages": {
    "saveSuccess": "변경 사항이 저장되었습니다",
    "saveError": "변경 사항 저장에 실패했습니다",
    "deleteConfirm": "이 항목을 삭제하시겠습니까?",
    "deleteSuccess": "항목이 삭제되었습니다",
    "deleteError": "항목 삭제에 실패했습니다",
    "networkError": "네트워크 오류가 발생했습니다. 연결 상태를 확인해 주세요.",
    "serverError": "서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
    "unauthorized": "이 작업을 수행할 권한이 없습니다."
  },
  "dateFormat": {
    "short": "YYYY.MM.DD",
    "long": "YYYY년 M월 D일",
    "withTime": "YYYY.MM.DD HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "이것은 VynaEMR 데모입니다 — 실제 환자 정보(PHI)를 입력하지 마십시오."
  },
  "network": {
    "offline": "오프라인 상태입니다. 임상 데이터가 저장되지 않을 수 있습니다."
  },
  "permissionDenied": {
    "title": "접근이 거부되었습니다",
    "body": "{{action}}할 권한이 없습니다.",
    "genericBody": "이 리소스를 볼 권한이 없습니다.",
    "requiredPermission": "필요한 권한: {{name}}",
    "contactAdmin": "오류라고 생각되시면 시스템 관리자에게 문의해 주세요.",
    "requiresPermissionCode": "권한 필요: {{code}}",
    "requiresLabel": "{{label}} 권한 필요",
    "requiresLabelWithRoles": "{{label}} 권한 필요 (보유자: {{roles}})",
    "insufficient": "권한이 부족합니다"
  },
  "skipToContent": "본문으로 건너뛰기",
  "openMenu": "메뉴 열기",
  "topBar": {
    "searchPlaceholder": "환자 검색 (MRN, 이름, ID)...",
    "recentPatients": "최근 환자",
    "searching": "검색 중...",
    "noPatientsFound": "환자를 찾을 수 없습니다. 검색하려면 Enter 키를 누르세요.",
    "notifications": "알림",
    "selectFacility": "시설 선택",
    "allFacilities": "모든 시설",
    "facilityLabel": "시설 {{id}}",
    "activeDepartment": "근무 부서",
    "selectDepartment": "근무 부서 선택",
    "noDepartmentSelected": "부서를 선택하세요",
    "departmentLabel": "부서 {{id}}",
    "departmentSwitchFailed": "전환하지 못했습니다"
  },
  "theme": {
    "toggle": "테마 전환",
    "light": "라이트",
    "dark": "다크",
    "system": "시스템",
    "current": "테마: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "정상 작동 중",
  "footerHealthIssue": "연결 문제",
  "dobLabel": "생년월일 {{date}}",
  "pagination": {
    "previous": "이전",
    "next": "다음",
    "pageOf": "{{current}} / {{total}} 페이지",
    "showing": "전체 {{total}}건 중 {{from}}–{{to}}건 표시",
    "loadMore": "더 보기"
  },
  "table": {
    "empty": "데이터가 없습니다",
    "loading": "로딩 중..."
  },
  "cdsAlert": {
    "severity": {
      "info": "정보",
      "warning": "경고",
      "critical": "심각"
    },
    "overridden": "재정의됨",
    "acknowledged": "확인됨",
    "justificationPlaceholder": "정당화 사유를 입력하세요...",
    "submit": "제출",
    "acknowledge": "확인",
    "override": "재정의",
    "regionAria": "임상 의사결정 지원(CDS) 경고",
    "acknowledgeFailed": "확인을 기록하지 못했습니다 — 저장되지 않았습니다. 다시 시도해 주세요.",
    "overrideFailed": "재정의를 기록하지 못했습니다 — 저장되지 않았습니다. 다시 시도해 주세요.",
    "addressedCount_one": "{{count}}건 처리됨",
    "addressedCount_other": "{{count}}건 처리됨"
  },
  "components": {
    "printButton": {
      "defaultLabel": "인쇄"
    },
    "codeSearch": {
      "searchPlaceholder": "코드 검색...",
      "clearAriaLabel": "선택 지우기",
      "noCodesFound": "코드를 찾을 수 없습니다"
    },
    "demographicPicker": {
      "addPlaceholder": "추가…",
      "loading": "불러오는 중…",
      "noneRecorded": "기록 없음",
      "removeAriaLabel": "{{value}} 제거",
      "unavailable": "값 목록을 사용할 수 없음",
      "unavailableHint": "값 목록을 불러올 수 없습니다. 기존 값은 변경되지 않으며 계속 저장됩니다.",
      "uncodedBadge": "코드 없음",
      "uncodedTitle": "코드화된 값이 도입되기 전에 기록되었습니다. 삭제할 수 있지만 다시 추가할 수는 없습니다."
    }
  },
  "pages": {
    "accessDenied": {
      "title": "접근이 거부되었습니다",
      "httpStatus": "HTTP 403",
      "body": "이 페이지를 볼 권한이 없습니다.",
      "attemptedLabel": "접근 시도:",
      "requiredPermissionLabel": "필요한 권한:",
      "typicallyHeldByLabel": "일반적으로 이 권한을 보유한 역할:",
      "signedInAs": "로그인 사용자:",
      "contactAdminHelp": "오류라고 판단되시면, 시스템 관리자 또는 부서장에게 연락하여 필요한 역할을 요청해 주십시오.",
      "goBack": "뒤로",
      "dashboard": "대시보드",
      "contact": "문의"
    },
    "notificationInbox": {
      "title": "알림",
      "markAllRead": "모두 읽음으로 표시",
      "loading": "알림을 불러오는 중…",
      "errorState": "알림을 불러오지 못했습니다.",
      "emptyState": "알림이 없습니다.",
      "ariaFilterStatus": "상태로 필터링",
      "ariaFilterPriority": "우선순위로 필터링",
      "ariaFilterType": "유형으로 필터링",
      "filterStatus": {
        "all": "전체",
        "unread": "읽지 않음",
        "read": "읽음"
      },
      "filterPriority": {
        "allLabel": "모든 우선순위",
        "critical": "위급",
        "high": "높음",
        "normal": "보통",
        "low": "낮음"
      },
      "filterType": {
        "allLabel": "모든 유형"
      },
      "notificationType": {
        "criticalResult": "위급 검사 결과",
        "orderUpdate": "처방 업데이트",
        "appointmentReminder": "예약 알림",
        "systemAlert": "시스템 알림",
        "cdsAlert": "임상 의사결정 알림",
        "result": "검사 결과",
        "handoffAssigned": "인계"
      },
      "toasts": {
        "allMarkedRead": "모든 알림을 읽음으로 표시했습니다",
        "markAllReadFailed": "모든 알림을 읽음으로 표시하지 못했습니다",
        "markReadFailed": "알림을 읽음으로 표시하지 못했습니다"
      }
    },
    "entityResolver": {
      "invalidId": "유효하지 않은 링크입니다.",
      "notFound": "찾을 수 없거나 접근 권한이 없습니다."
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "실시간 업데이트를 사용할 수 없음",
    "body": "연결이 복구될 때까지 새 결과와 알림이 자동으로 도착하지 않습니다.",
    "authBody": "세션이 만료되었습니다. 실시간 업데이트를 복구하려면 다시 로그인하세요.",
    "retry": "다시 시도",
    "login": "로그인"
  }
}
